import _implicitStylesheets from "./explore.css";
import _implicitScopedStylesheets from "./explore.scoped.css?scoped=true";
import _wdsChip from "wds/chip";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _wdsExploreBucket from "wds/exploreBucket";
import _aceFilterPanel from "ace/filterPanel";
import _wdsButton from "wds/button";
import _wdsSortOptions from "wds/sortOptions";
import _searchResults from "search/results";
import _wdsError from "wds/error";
import _wdsCardGrid from "wds/cardGrid";
import _wdsContentTitle from "wds/contentTitle";
import _wdsContentText from "wds/contentText";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment2 = parseFragment`<div class="explore-container-title${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<p class="chips-title${0}" role="status" type-style="body-3"${2}>${"t1"}<span class="visually-hidden${0}"${2}>${"t3"}</span></p>`;
const stc0 = {
  classMap: {
    "page-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "content-container": true
  },
  attrs: {
    "grid": "",
    "align-items": "spread"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "filters": true
  },
  attrs: {
    "size": "4:12"
  },
  key: 2
};
const stc3 = {
  classMap: {
    "filter-chips": true,
    "mobile-filter-chips": true
  },
  key: 3
};
const stc4 = {
  "type": "filter"
};
const stc5 = {
  classMap: {
    "bucket-section": true
  },
  key: 7
};
const stc6 = {
  "filter-panel": true
};
const stc7 = {
  "show-advanced-filters-button": true
};
const stc8 = {
  "close-button": true
};
const stc9 = {
  "data-testid": "closeButton"
};
const stc10 = {
  classMap: {
    "explore-container": true
  },
  attrs: {
    "size": "12:12@x-small 8:12@large"
  },
  key: 14
};
const stc11 = {
  key: 19
};
const stc12 = {
  classMap: {
    "filter-chips": true
  },
  key: 22
};
const stc13 = {
  classMap: {
    "button-container": true
  },
  key: 26
};
const stc14 = {
  "add-filter-button": true
};
const stc15 = {
  "data-testid": "openFiltersButton"
};
const stc16 = {
  props: {
    "skeletonCount": "2",
    "columnSize": "4:4@x-small 4:8@medium",
    "columnGap": "large",
    "isLoading": "true"
  },
  key: 31
};
const stc17 = {
  "listings": true
};
const stc18 = {
  "data-testid": "explore-section"
};
const stc19 = {
  classMap: {
    "header": true
  },
  key: 33
};
const stc20 = {
  classMap: {
    "title-and-subtitle": true
  },
  key: 34
};
const stc21 = {
  attrs: {
    "name": "tooltip_slot"
  },
  key: 36
};
const stc22 = [];
const stc23 = {
  key: 37
};
const stc24 = {
  "sponsored-tiles": true
};
const stc25 = {
  classMap: {
    "showmore-bottom": true
  },
  key: 40
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, b: api_bind, c: api_custom_element, h: api_element, i: api_iterator, sp: api_static_part, st: api_static_fragment, ncls: api_normalize_class_name, d: api_dynamic_text, s: api_slot, t: api_text, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [$cmp.shouldDisplayFilters ? api_element("div", stc2, [$cmp.mobileFilterChips ? api_element("ul", stc3, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(4, filterChip.value)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc4,
      key: 5,
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleFilterAnalytics))
      }
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 6,
      on: {
        "close": _m1 || ($ctx._m1 = api_bind($cmp.handleChipClosed))
      }
    })])]);
  })) : null, api_element("div", stc5, api_iterator($cmp.bucketSectionOptions, function (option) {
    return api_custom_element("wds-explore-bucket", _wdsExploreBucket, {
      props: {
        "label": option.label,
        "value": option.value,
        "selected": option.selected,
        "icon": option.icon
      },
      key: api_key(8, option.value),
      on: {
        "bucketchange": _m2 || ($ctx._m2 = api_bind($cmp.handleBucketClick))
      }
    });
  })), api_custom_element("ace-filter-panel", _aceFilterPanel, {
    classMap: stc6,
    props: {
      "container": "explore",
      "options": $cmp.filterSections,
      "searchable": "true"
    },
    key: 9,
    on: {
      "filterchange": _m3 || ($ctx._m3 = api_bind($cmp.handleFilterSelectionChange)),
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleFilterAnalytics))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc7,
    props: {
      "variant": "secondary",
      "width": "fill",
      "name": "show advanced filters",
      "label": $cmp.labels.showAdvancedFilters
    },
    key: 10,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleShowAdvancedFilters)),
      "analytics": _m6 || ($ctx._m6 = api_bind($cmp.handleAnalytics))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc8,
    attrs: stc9,
    props: {
      "variant": "secondary",
      "width": "fill",
      "name": "mobileFiltersButton",
      "label": $cmp.closeButtonText
    },
    key: 11,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.switchMobileFilterPanel))
    }
  })]) : null, $cmp.shouldDisplayFilters ? $cmp.mobileFilterPanel ? api_static_fragment($fragment1, 13, [api_static_part(0, {
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.switchMobileFilterPanel))
    }
  }, null)]) : null : null, api_element("div", stc10, api_flatten([api_element("div", {
    className: api_normalize_class_name($cmp.filterHeaderClass),
    key: 15
  }, [api_static_fragment($fragment2, 17, [api_static_part(1, null, api_dynamic_text($cmp.pageTitle))]), !$cmp.isSearchError ? api_element("div", {
    className: api_normalize_class_name($cmp.filterContainerClass),
    key: 18
  }, [$cmp.showFilterChips ? api_element("div", stc11, [api_static_fragment($fragment3, 21, [api_static_part(1, null, api_dynamic_text($cmp.filterByLabel)), api_static_part(3, null, api_dynamic_text($cmp.filterByAria))]), api_element("ul", stc12, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(23, filterChip.value)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc4,
      key: 24,
      on: {
        "analytics": _m10 || ($ctx._m10 = api_bind($cmp.handleFilterAnalytics))
      }
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 25,
      on: {
        "close": _m11 || ($ctx._m11 = api_bind($cmp.handleChipClosed))
      }
    })])]);
  }))]) : null, api_element("div", stc13, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc14,
    attrs: stc15,
    props: {
      "variant": $cmp.buttonVariant,
      "ariaExpanded": $cmp.displayMobileFilterPanel,
      "name": "addFilters",
      "label": $cmp.addFilterButtonText
    },
    key: 27,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.switchMobileFilterPanel))
    }
  }), !$cmp.hideSortButton ? api_custom_element("wds-sort-options", _wdsSortOptions, {
    props: {
      "variant": $cmp.buttonVariant,
      "options": $cmp.sortOptions,
      "selectedOption": $cmp.selectedSortOption
    },
    key: 28,
    on: {
      "sortselectionchange": _m13 || ($ctx._m13 = api_bind($cmp.handleSortSelectionChange)),
      "analytics": _m14 || ($ctx._m14 = api_bind($cmp.handleAnalytics))
    }
  }) : null])]) : null]), $cmp.showSearchResults ? api_custom_element("search-results", _searchResults, {
    key: 29,
    on: {
      "searchtypechange": _m15 || ($ctx._m15 = api_bind($cmp.handleSwitch))
    }
  }) : null, !$cmp.showSearchResults ? api_flatten([$cmp.isBucketError ? api_custom_element("wds-error", _wdsError, {
    props: {
      "handleButtonClick": $cmp.handleRetry
    },
    key: 30
  }) : null, $cmp.isInitialLoading ? api_custom_element("wds-card-grid", _wdsCardGrid, stc16) : null, api_iterator($cmp.categorySections, function (section) {
    return $cmp.showBucketResults ? api_element("div", {
      classMap: stc17,
      attrs: stc18,
      key: api_key(32, section.name)
    }, [api_element("div", stc19, [api_element("div", stc20, [api_custom_element("wds-content-title", _wdsContentTitle, {
      props: {
        "level": "7",
        "truncate": "false",
        "isLoading": $cmp.isLoading,
        "title": section.label
      },
      key: 35
    }, [api_slot("tooltip_slot", stc21, stc22, $slotset)]), api_custom_element("wds-content-text", _wdsContentText, stc23, [api_text(api_dynamic_text($cmp.labels.section.subTitle))])]), !$cmp.isMobilePhone ? api_custom_element("wds-button", _wdsButton, {
      props: {
        "variant": "text",
        "icon": "chevronright",
        "iconPlacement": "end",
        "href": section.props.showMore.url,
        "label": section.props.showMore.label
      },
      key: 38
    }) : null]), api_custom_element("wds-card-grid", _wdsCardGrid, {
      classMap: stc24,
      props: {
        "listingRecords": section.listings,
        "skeletonCount": "2",
        "columnSize": "4:4@x-small 4:8@medium",
        "columnGap": "large",
        "isLoading": $cmp.isLoading
      },
      key: 39,
      on: {
        "analytics": _m16 || ($ctx._m16 = api_bind($cmp.handleAnalytics))
      }
    }), api_element("div", stc25, [$cmp.isMobilePhone ? api_custom_element("wds-button", _wdsButton, {
      props: {
        "variant": "text",
        "icon": "chevronright",
        "iconPlacement": "end",
        "href": section.props.showMore.url,
        "label": section.props.showMore.label
      },
      key: 41
    }) : null])]) : null;
  })]) : stc22]))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["tooltip_slot"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-48v19lfku4j";
tmpl.legacyStylesheetToken = "undefined-_explore";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
